import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["delta"];

  static values = { chartId: Number };

  connect() {
    // Add click handler for delta toggle
    this.deltaTarget.addEventListener("click", this.toggleChanges.bind(this));
  }

  async toggleChanges(event) {
    event.preventDefault();
    event.stopPropagation();

    try {
      // Make AJAX request to toggle show_changes
      const response = await fetch(
        `/admin/portal_analytics_charts/${this.chartIdValue}/toggle_changes`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": Rails.csrfToken(),
          },
        },
      );

      if (response.ok) {
        // Refresh the page to show the updated chart
        window.location.reload();
      } else {
        // eslint-disable-next-line no-console
        console.error("Failed to toggle changes:", response.statusText);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error toggling changes:", error);
    }
  }
}
